var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeopleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "people-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.166.5h20v20h-20z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#people-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.166 10.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10M10.166 12.167a7.51 7.51 0 0 0-7.5 7.5.833.833 0 1 0 1.667 0 5.833 5.833 0 0 1 11.666 0 .833.833 0 1 0 1.667 0 7.51 7.51 0 0 0-7.5-7.5"
}))));
export { SvgPeopleIcon as ReactComponent };
export default __webpack_public_path__ + "964673bd116e09aeee0800b94a4712d6.svg";